import { render } from "./CompetenceDirectoryModalImport.vue?vue&type=template&id=20417905"
import script from "./CompetenceDirectoryModalImport.vue?vue&type=script&lang=js"
export * from "./CompetenceDirectoryModalImport.vue?vue&type=script&lang=js"

import "./CompetenceDirectoryModalImport.vue?vue&type=style&index=0&id=20417905&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__